<!--
 * @Author       : Tom
 * @Date         : 2019-12-16 10:19:24
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-12 21:11:26
 * @FilePath     : /shop_front_end/src/App.vue
 * @Description  : 挂载入口
 -->

<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <router-view/>
    </a-locale-provider>
  </div>
</template>
<script>
// 国际化
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  data() {
    return {
      locale: zhCN
    }
  }
}
</script>
<style>
/* 公共css */
.ant-card-wider-padding .ant-card-body {
  padding: 0px 0px !important;
}

.ant-card {
  height: 100%;
}

.ant-radio-button-wrapper-checked[class]{
	color: #03A2F4!important;
	border-color: #03A2F4!important;
}

</style>
